// lazy load plugin
document.addEventListener('DOMContentLoaded', function () {
  // Load only HTML components marked with `data-include="path/to/file.html"`.
  // Do NOT touch elements using `data-src` (e.g. lazy-loaded media).
  document.querySelectorAll('[data-include]').forEach(function (el) {
    var url = el.getAttribute('data-include');
    fetch(url).then(function (res) { if (!res.ok) throw new Error(res.statusText); return res.text(); })
      .then(function (html) { el.innerHTML = html; })
      .catch(function (err) { console.error('Failed to load component', url, err); el.innerHTML = '<p>Не удалось загрузить компонент.</p>'; });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('.video-popup');
  var player = popup && popup.querySelector('.video-popup__player');
  var video = popup && popup.querySelector('.video-popup__video');
  var soundButton = popup && popup.querySelector('.video-popup__sound');
  var soundIcon = soundButton && soundButton.querySelector('img');
  var closeButton = popup && popup.querySelector('.video-popup__close');
  var pauseButton = popup && popup.querySelector('.video-popup__pause');
  var restartButton = popup && popup.querySelector('.video-popup__restart');
  var expandButton = popup && popup.querySelector('.video-popup__expand');
  var investmentLink = popup && popup.querySelector('.video-popup__link');
  var pauseIndicatorTimer = null;
  var popupTransitionTimer = null;
  var isExpanded = false;
  var previousScrollY = window.scrollY;

  if (!popup || !player || !video || !soundButton || !soundIcon || !closeButton || !pauseButton || !restartButton || !expandButton || !investmentLink) return;

  function updateSoundButton() {
    var isMuted = video.muted || video.volume === 0;
    soundButton.setAttribute('aria-label', isMuted ? 'Включить звук' : 'Выключить звук');
    soundButton.setAttribute('aria-pressed', String(!isMuted));
    soundIcon.src = isMuted
      ? 'assets/src/assets/img/opif/no-volume.svg'
      : 'assets/src/assets/img/opif/volume.svg';
  }

  function setPopupExpanded(expanded) {
    if (expanded === isExpanded) return;
    isExpanded = expanded;

    if (popupTransitionTimer) window.clearTimeout(popupTransitionTimer);

    if (expanded) {
      popup.classList.remove('is-closed', 'is-collapsing', 'is-expanded');
      popup.classList.add('is-scroll-visible', 'is-expanding');
      popupTransitionTimer = window.setTimeout(function () {
        if (!isExpanded) return;
        popup.classList.remove('is-expanding');
        popup.classList.add('is-expanded');
        video.play().catch(function () {});
        popupTransitionTimer = null;
      }, 300);
      return;
    }

    video.pause();
    popup.classList.remove('is-expanding', 'is-expanded');
    popup.classList.add('is-collapsing');
    popupTransitionTimer = window.setTimeout(function () {
      if (isExpanded) return;
      popup.classList.remove('is-collapsing');
      popup.classList.add('is-closed');
      popupTransitionTimer = null;
    }, 350);
  }

  function updatePopupVisibility() {
    popup.classList.add('is-scroll-visible');
    var currentScrollY = window.scrollY;

    if (previousScrollY < 300 && currentScrollY >= 300 && !isExpanded) {
      setPopupExpanded(true);
    } else if (previousScrollY >= 300 && currentScrollY < 300 && isExpanded) {
      setPopupExpanded(false);
    }

    previousScrollY = currentScrollY;
  }

  function showPauseIndicator(isPlaying) {
    var pauseIcon = pauseButton.querySelector('img');
    if (pauseIndicatorTimer) window.clearTimeout(pauseIndicatorTimer);

    pauseIcon.src = isPlaying
      ? 'assets/src/assets/img/opif/pause.svg'
      : 'assets/src/assets/img/opif/play.svg';
    pauseButton.setAttribute('aria-label', isPlaying ? 'Видео воспроизводится' : 'Воспроизвести видео');
    pauseButton.classList.add('is-visible');

    if (isPlaying) {
      pauseIndicatorTimer = window.setTimeout(function () {
        pauseButton.classList.remove('is-visible');
        pauseIndicatorTimer = null;
      }, 800);
    }
  }

  soundButton.addEventListener('click', function (event) {
    event.stopPropagation();
    video.muted = !video.muted;
    updateSoundButton();
  });

  closeButton.addEventListener('click', function (event) {
    event.stopPropagation();
    setPopupExpanded(false);
  });

  pauseButton.addEventListener('click', function (event) {
    event.stopPropagation();
    video.pause();
  });

  restartButton.addEventListener('click', function (event) {
    event.stopPropagation();
    video.currentTime = 0;
    video.play().catch(function () {});
  });

  expandButton.addEventListener('click', function () {
    setPopupExpanded(true);
  });

  investmentLink.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || investmentLink.classList.contains('is-navigating')) return;

    event.preventDefault();
    investmentLink.classList.add('is-navigating');
    window.setTimeout(function () {
      window.location.href = investmentLink.href;
    }, 500);
  });

  video.addEventListener('click', function () {
    if (video.paused) {
      video.play().catch(function () {});
    } else {
      video.pause();
    }
  });

  video.addEventListener('ended', function () {
    pauseButton.classList.remove('is-visible');
    restartButton.classList.add('is-visible');
  });

  video.addEventListener('play', function () {
    restartButton.classList.remove('is-visible');
    showPauseIndicator(true);
  });

  video.addEventListener('pause', function () {
    if (!video.ended) showPauseIndicator(false);
  });

  video.addEventListener('volumechange', updateSoundButton);
  window.addEventListener('scroll', updatePopupVisibility, { passive: true });
  popup.classList.add('is-closed');
  video.muted = true;
  video.pause();
  updateSoundButton();
  updatePopupVisibility();
});